const Builder = require('./BuilderBase');
const ToUpperCase = require('./transforms/ToUpperCase');
const ToLowerCase = require('./transforms/ToLowerCase');
const ToBoolean = require('./transforms/ToBoolean');
const ToNumber = require('./transforms/ToNumber');
const ToHexFromAscii = require('./transforms/ToHexFromAscii');
const ToAsciiFromHex = require('./transforms/ToAsciiFromHex');

module.exports = class MarkRecord extends Builder {
    constructor(title, properties) {
        super('actionElement_MarkRecord', title, properties);
    }

    /**
     * @param {boolean} transformInline
     */
    transformToUpperCase(transformInline) {
        let transform = new ToUpperCase({ transformInline });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    /**
     * @param {boolean} transformInline
     */
    transformToLowerCase(transformInline) {
        let transform = new ToLowerCase({ transformInline });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    /**
     * @param {string} falseValues
     */
    transformToBoolean(falseValues) {
        let transform = new ToBoolean({ falseValues });
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToNumber() {
        let transform = new ToNumber();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToAsciiFromHex() {
        let transform = new ToAsciiFromHex();
        this.addChildBlock(transform, 'transforms');
        return this;
    }

    transformToHexFromAscii() {
        let transform = new ToHexFromAscii();
        this.addChildBlock(transform, 'transforms');
        return this;
    }
};
